export default __webpack_public_path__ + "static/media/icon-laptop-bg-black.4d1ed713.svg";